export function convertToSlug(text: string): string {
  if (!text) return '';

  return text
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w.\-~]/g, '') // Keep unreserved characters: alphanumeric, hyphen, period, underscore, tilde
    .replace(/-+/g, '-') // Replace consecutive hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
}
